<template>
  <v-row no-gutters justify="center">
    <v-card color="companyTertiary" width="450px">
      <v-card-title class="white--text">{{ getCardTitle }}</v-card-title>
      <v-card-text
        v-if="isValidationOngoing"
        class="white pa-5 d-flex justify-center"
      >
        <v-progress-circular
          indeterminate
          :size="70"
          color="companyPrimary"
        ></v-progress-circular>
      </v-card-text>
      <div v-if="!isValidationOngoing && errorCode == null">
        <v-card-text class="white px-5 pb-0 pt-5">
          <div class="d-flex">
            <v-icon x-large color="success" class="mr-2"
              >mdi-check-circle-outline</v-icon
            >
            <div>
              Your e-mail has been correctly validated. You should receive an
              e-mail with your credentials. Please login to complete your
              registration process.
            </div>
          </div>
        </v-card-text>
        <v-card-text class="white pa-5">
          If you do not receive our confirmation e-mail in the next two hours,
          please
          <a :href="'mailto:' + getLegalEntity.recruitmentMail">contact us</a>.
        </v-card-text>
      </div>
      <div v-if="!isValidationOngoing && errorCode == 0">
        <v-card-text class="white pa-5">
          It seems that your confirmation token has expired.
        </v-card-text>
        <v-card-text class="white px-5 pb-5 pt-0 font-weight-bold">
          Please request a new token to confirm your e-mail.
        </v-card-text>
      </div>
      <div v-if="!isValidationOngoing && errorCode == 1">
        <v-card-text class="white pa-5">
          It seems that the token you used is not valid. Bye.
        </v-card-text>
      </div>
      <div v-if="!isValidationOngoing && errorCode == 2">
        <v-card-text class="white pa-5"> WAT??? </v-card-text>
      </div>
      <v-card-actions v-if="errorCode < 1" class="white">
        <v-btn
          v-if="!isValidationOngoing && errorCode == null"
          block
          color="primary"
          :to="{ name: 'login' }"
        >
          Back To Login
        </v-btn>
        <v-btn
          v-if="!isValidationOngoing && errorCode == 0"
          block
          color="primary"
          :loading="newTokenLoading"
          :disabled="newTokenRequestDone"
          @click="requestNewToken()"
        >
          {{ requestNewTokenBtn }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { RegistrationService } from "@/services";

export default {
  name: "ConfirmEmailView",
  data() {
    return {
      isValidationOngoing: true,
      errorCode: null,
      requestNewTokenBtn: "Request New Token",
      newTokenLoading: false,
      newTokenRequestDone: false,
    };
  },
  computed: {
    ...mapGetters("domain", ["getLegalEntity"]),

    getCardTitle() {
      if (this.isValidationOngoing) return "Validating your e-mail...";
      if (!this.isValidationOngoing && this.errorCode == null)
        return "Everything seems ok...";
      return "Ouch, something went wrong...";
    },
  },
  mounted() {
    this.sendValidation();
  },
  methods: {
    ...mapActions({
      setSnackBar: "setSnackBar",
    }),
    async sendValidation() {
      try {
        await RegistrationService.validateEmail(this.$route.query.token);
      } catch (error) {
        this.errorCode = error.response.data.code;
      }
      this.isValidationOngoing = false;
    },
    async requestNewToken() {
      this.newTokenLoading = true;
      try {
        await RegistrationService.renewToken(this.$route.query.token);
        this.requestNewTokenBtn = "Token Requested!";
        this.newTokenRequestDone = true;
      } catch (error) {
        this.errorCode = error.response.data.code;
      }
      this.newTokenLoading = false;
    },
  },
};
</script>
